import { RestApiDeliveryMethodDto } from '@order-mage/integration-sdk';

export const isDeliveryMethod = (method: RestApiDeliveryMethodDto): boolean => !!method.areas?.length;
